import { FC, useState } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  Favorite,
  ShoppingBag,
  Wallet,
} from '@mui/icons-material';
import { formatPrice } from '@vs-online-only-app/ui';
import { AssociateInsight } from '@vs-online-only-app/state';
import StatsBox from './InsightsBox';
import { BoxesContainer } from './Insights';

interface Props {
  associateInsights: AssociateInsight[];
}

const InsightsBoxes: FC<Props> = ({ associateInsights }) => {
  const [page, setPage] = useState(associateInsights.length - 1); // Start at the last page

  const currentInsights = associateInsights[page];
  const canGoToNextPage = associateInsights.length > page + 1;
  const canGoToPreviousPage = page > 0;
  const date = currentInsights?.date
    ? new Date(currentInsights.date).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
      })
    : '-';

  const goToNextPage = () => {
    if (!canGoToNextPage) return;
    setPage((prevPage) => prevPage + 1);
  };

  const goToPreviousPage = () => {
    if (!canGoToPreviousPage) return;
    setPage((prevPage) => prevPage - 1);
  };

  return (
    <Stack gap={1}>
      <Stack
        direction="row"
        gap={0.5}
        alignItems="center"
        width="100%"
        justifyContent="space-between"
      >
        <Typography variant="h5">Your metrics</Typography>
        <Stack direction="row" gap={1} alignItems="center">
          <IconButton
            size="small"
            onClick={goToPreviousPage}
            disabled={!canGoToPreviousPage}
            edge="start"
          >
            <ChevronLeft />
          </IconButton>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ userSelect: 'none' }}
          >
            {date}
          </Typography>
          <IconButton
            size="small"
            onClick={goToNextPage}
            disabled={!canGoToNextPage}
            edge="end"
          >
            <ChevronRight />
          </IconButton>
        </Stack>
      </Stack>
      <BoxesContainer>
        <StatsBox
          icon={<Favorite sx={{ color: '#FFB4C8' }} />}
          title="Customers"
        >
          {currentInsights?.chats || 0}
        </StatsBox>
        <StatsBox icon={<Wallet sx={{ color: '#29A1FF' }} />} title="Sales">
          {formatPrice(currentInsights?.value || '-')}
        </StatsBox>
        <StatsBox
          icon={<ShoppingBag sx={{ color: '#E19F00' }} />}
          title="Orders"
        >
          {currentInsights?.sales || 0}
        </StatsBox>
      </BoxesContainer>
    </Stack>
  );
};

export default InsightsBoxes;
